var _linearGradient, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 300,
    y1: 685,
    x2: 300,
    y2: -63,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.9 250.5h-35.6c-19.6-54.4-72.3-91.7-141.8-91.7H186.2v91.7h-39.7v32.9h39.7v34.5h-39.7v32.9h39.7v90.6h114.3c68.7 0 121-37 141.1-90.6h36.3v-32.9h-28.3c.7-5.8 1.1-11.8 1.1-17.8v-.8c0-5.4-.3-10.7-.8-15.9H478v-32.9zm-259.7-62.4h82.3c51 0 88.9 25.1 106.4 62.3H218.2v-62.3zm82.3 223.7h-82.3v-61.1h188.5c-17.6 36.6-55.4 61.1-106.2 61.1zm117.1-111c0 5.8-.4 11.5-1.2 17H218.2v-34.5h198.3c.7 5.4 1.1 11 1.1 16.7v.8z",
    fill: "#212138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.393f76167fe4e228d61386ce16daf1b3.svg";
export { ForwardRef as ReactComponent };